import projCardItem from "./proj-card-item";
export default projCardItem;
